import { ProDetailList } from '@bedrock/eed-react';
import {
  FormItemAddressDetail,
  FormItemBankAccountLocale,
  FormItemBankAccountName,
  FormItemBankAccountNumber,
  FormItemBankAccountType,
  FormItemBankBranchName,
  FormItemBankCcCode,
  FormItemBankDetailList,
  FormItemBankOpenCityName,
  FormItemBankOpenName,
  FormItemBankOpenProvinceName,
  FormItemBankSupportFile,
  FormItemRegisterCountry,
  FormItemSwiftCode,
  FormCard,
  FormModule,
} from '@purchase/supplier';
import React, { useMemo } from 'react';
import { get } from 'lodash-es';

const BankInfo = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'card', formDetail } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const bankCount = useMemo(
    () => get(formDetail, [...namePath, 'vendorBankInfos'])?.length ?? 0,
    [formDetail, namePath]
  );

  return (
    <Wrapper
      title="银行账户信息"
      titleCount={bankCount}
      proCardProps={{ expandable: true, defaultExpanded: bankCount > 0 }}
    >
      <FormItemBankDetailList name={[...namePath, 'vendorBankInfos']}>
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => {
            return index + 1;
          }}
        </ProDetailList.Item>
        <FormItemBankAccountNumber
          name="account"
          label="银行账号/IBAN"
          meta={{
            columnProps: { width: 200, className: 'font-semibold', fixed: true },
          }}
        />
        <FormItemBankAccountName
          name="accountName"
          label="账户名称"
          meta={{ columnProps: { width: 240 } }}
        />
        <FormItemBankAccountLocale
          name="bankAccountLocale"
          label="账户语种"
          meta={{ columnProps: { width: 120 } }}
        />
        <FormItemBankOpenName
          name="openBankName"
          label="银行名称"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemBankBranchName
          name="branchName"
          label="银行及分支行"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemRegisterCountry
          name="country"
          label="开户行国家/地区"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemBankOpenProvinceName
          name="openProvinceName"
          label="开户行省"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemBankOpenCityName
          name="openCityName"
          label="开户行市"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemBankDetailList.More>
          <FormItemAddressDetail
            label="供应商银行预留地址"
            name="vendorAddress"
          />
          <FormItemSwiftCode span={2} label="Swift Code" name="swiftCode" />
          <FormItemBankCcCode
            span={2}
            label="开户行本地清算编码"
            name="ccCode"
          />
          <FormItemAddressDetail span={2} label="银行地址" name="address" />
          <FormItemBankAccountType
            span={2}
            label="账户种类"
            name="bankAccountCategory"
          />
          <FormItemBankSupportFile
            span={2}
            label="支持文件"
            name="supportFile"
          />
        </FormItemBankDetailList.More>
      </FormItemBankDetailList>
    </Wrapper>
  );
};

export default BankInfo;
